import React from 'react';

const ValueProposition1 = ({ ...props }) => (
  <svg
    width="545"
    height="540"
    viewBox="0 0 545 540"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M534.946 540H10.0538C7.38738 540 4.83014 538.942 2.94469 537.058C1.05923 535.174 0 532.619 0 529.954V271.891C9.00365e-07 270.57 0.260564 269.263 0.766739 268.043C1.27291 266.823 2.0148 265.715 2.94994 264.782L265.396 2.93704C267.281 1.05633 269.836 0 272.5 0C275.164 0 277.719 1.05633 279.604 2.93704L542.05 264.782C542.985 265.715 543.727 266.823 544.233 268.043C544.739 269.263 545 270.57 545 271.891V529.954C545 532.619 543.941 535.174 542.055 537.058C540.17 538.942 537.613 540 534.946 540Z"
      fill="#14477D"
    />
  </svg>
);

export default ValueProposition1;
